import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')


// Views
const Dashboard = () => import('@/views/Dashboard')

// Auth
const Login = () => import('@/views/pages/Login/Index')

// Institutional
const Terms = () => import('@/views/institutional/Terms/Index')
const PrivacyPolicy = () => import('@/views/institutional/PrivacyPolicy/Index')

// Banners
const Banners = () => import('@/views/Banners/Index')
const BannerList = () => import('@/views/Banners/components/List/Index')
const BannerForm = () => import('@/views/Banners/components/Form/Index')

// Home config
const Home = () => import('@/views/Home/Index')
const HomeVideo = () => import('@/views/Home/components/Video/Index')
const HomeTarget = () => import('@/views/Home/components/Target/Index')
const HomeStartNow = () => import('@/views/Home/components/StartNow/Index')
const HomePhotos = () => import('@/views/Home/components/Photos/Index')

// Posts
const Posts = () => import('@/views/Posts/Index')
const PostList = () => import('@/views/Posts/components/PostList/Index')
const PostForm = () => import('@/views/Posts/components/PostForm/Index')

// Events
const Events = () => import('@/views/Events/Index')
const EventsList = () => import('@/views/Events/components/List/Index')
const EventDetails = () => import('@/views/Events/components/Details/Index')

// Settings
const Settings = () => import('@/views/Settings/Index')
const MessageTemplates = () => import('@/views/Settings/MessageTemplates/Index')
const EditTemplate = () => import('@/views/Settings/MessageTemplates/components/EditTemplate/Index')
const SystemSettings = () => import('@/views/Settings/System/Index')
const EditSetting = () => import('@/views/Settings/System/components/EditSetting/Index')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/Users/Index')
const UsersList = () => import('@/views/Users/components/List/Index')
const UserProfile = () => import('@/views/Users/components/Profile/Index')

// Reports
const Reports = () => import('@/views/Reports/Index')
const ProfessionalCategoryReport = () => import('@/views/Reports/components/ProfessionalCategoryReport/Index')
const IncompleteAccountsReport = () => import('@/views/Reports/components/IncompleteAccountsReport/Index')
const NoVideoWorkProfileReport = () => import('@/views/Reports/components/NoVideoWorkProfileReport/Index')
const BestRatedProfilesReport = () => import('@/views/Reports/components/BestRatedProfilesReport/Index')
const MessagingLog = () => import('@/views/Reports/components/MessagingLog/Index')
const SymplaJobsReport = () => import('@/views/Reports/components/SymplaJobsReport/Index')

// FrequentlyAskedQuestions
const FrequentlyAskedQuestions = () => import('@/views/FrequentlyAskedQuestions/Index')
const FrequentlyAskedQuestionsList = () => import('@/views/FrequentlyAskedQuestions/components/List/Index')
const FrequentlyAskedQuestionsForm = () => import('@/views/FrequentlyAskedQuestions/components/Form/Index')

// SymplaEvents
const SymplaEvents = () => import('@/views/SymplaEvents/Index')
const SymplaEventsList = () => import('@/views/SymplaEvents/components/List/Index')
const SymplaEventsForm = () => import('@/views/SymplaEvents/components/Form/Index')

// SymplaTokens
const SymplaTokens = () => import('@/views/SymplaTokens/Index')
const SymplaTokensList = () => import('@/views/SymplaTokens/components/List/Index')
const SymplaTokensForm = () => import('@/views/SymplaTokens/components/Form/Index')

Vue.use(Router)

let router = new Router({
    mode: 'hash', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({y: 0}),
    routes: configRoutes(),
})

router.beforeEach((to, from, next) => {
    if (to.meta.private && (!store.state.session.token || !store.state.session.user)) {
        store.commit('unsetTokens')
        next({name: 'Login'})
        return
    }

    next()
})

export default router

function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            component: TheContainer,
            children: [
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: 'terms',
                    name: 'Termos de Uso',
                    component: Terms
                },
                {
                    path: 'privacy_policy',
                    name: 'Política de Privacidade',
                    component: PrivacyPolicy
                },
                {
                    path: 'events',
                    name: 'Eventos',
                    component: Events,
                    children: [
                        {
                            path: 'list',
                            name: 'Listar eventos',
                            component: EventsList
                        },
                        {
                            path: 'details/:id',
                            name: 'Detalhes do evento',
                            component: EventDetails
                        }
                    ]
                },
                {
                    path: 'posts',
                    name: 'Recados para Prestadores',
                    component: Posts,
                    children: [
                        {
                            path: 'list',
                            name: 'Ver recados',
                            component: PostList
                        },
                        {
                            path: 'create',
                            name: 'Novo recado',
                            component: PostForm
                        },
                        {
                            path: 'edit/:id',
                            name: 'Editar recado',
                            component: PostForm
                        }
                    ]
                },
                {
                    path: 'users',
                    name: 'Usuarios',
                    component: Users,
                    children: [
                        {
                            path: 'list',
                            name: 'Ver usuários',
                            component: UsersList
                        },
                        {
                            path: 'profile/:id',
                            name: 'Detalhes do Usuário',
                            component: UserProfile
                        }
                    ]
                },
                {
                    path: 'settings',
                    name: 'Configurações',
                    component: Settings,
                    children: [
                        {
                            path: 'message_templates',
                            name: 'Templates de mensagens',
                            component: MessageTemplates
                        },
                        {
                            path: 'edit_template/:id',
                            name: 'Editar Template',
                            component: EditTemplate
                        },
                        {
                            path: 'system',
                            name: 'Sistema',
                            component: SystemSettings
                        },
                        {
                            path: 'system/edit/:id',
                            name: 'Alterar configuração',
                            component: EditSetting
                        }
                    ]
                },
                {
                    path: 'banners',
                    name: 'Banners',
                    component: Banners,
                    children: [
                        {
                            path: 'list',
                            name: 'Ver banners',
                            component: BannerList
                        },
                        {
                            path: 'create',
                            name: 'Criar banner',
                            component: BannerForm
                        },
                        {
                            path: 'edit/:id',
                            name: 'Editar banner',
                            component: BannerForm
                        }
                    ]
                },
                {
                    path: 'home',
                    name: 'Configurações da Home',
                    component: Home,
                    children: [
                        {
                            path: 'video',
                            name: 'Editar vídeo',
                            component: HomeVideo
                        },
                        {
                            path: 'target',
                            name: 'Pra quem é',
                            component: HomeTarget
                        },
                        {
                            path: 'start_now',
                            name: 'Comece Agora',
                            component: HomeStartNow
                        },
                        {
                            path: 'photos',
                            name: 'Fotos',
                            component: HomePhotos
                        }
                    ]
                },
                {
                    path: 'frequently_asked_questions',
                    name: 'FrequentlyAskedQuestions',
                    component: FrequentlyAskedQuestions,
                    children: [
                        {
                            path: 'list',
                            name: 'Listar FAQ',
                            component: FrequentlyAskedQuestionsList
                        },
                        {
                            path: 'create',
                            name: 'Adicionar pergunta ao FAQ',
                            component: FrequentlyAskedQuestionsForm
                        },
                        {
                            path: 'edit/:id',
                            name: 'Editar pergunta do FAQ',
                            component: FrequentlyAskedQuestionsForm
                        }
                    ]
                },
                {
                    path: 'sympla_events',
                    name: 'Eventos Sympla',
                    component: SymplaEvents,
                    children: [
                        {
                            path: 'list',
                            name: 'Listar Eventos Sympla',
                            component: SymplaEventsList
                        },
                        {
                            path: 'create',
                            name: 'Adicionar Evento Sympla',
                            component: SymplaEventsForm
                        },
                        {
                            path: 'edit/:id',
                            name: 'Editar Evento Sympla',
                            component: SymplaEventsForm
                        }
                    ]
                },
                {
                    path: 'sympla_tokens',
                    name: 'Tokens Sympla',
                    component: SymplaTokens,
                    children: [
                        {
                            path: 'list',
                            name: 'Listar Tokens Sympla',
                            component: SymplaTokensList
                        },
                        {
                            path: 'create',
                            name: 'Adicionar Token Sympla',
                            component: SymplaTokensForm
                        },
                        {
                            path: 'edit/:id',
                            name: 'Editar Token Sympla',
                            component: SymplaTokensForm
                        }
                    ]
                },
                {
                    path: 'reports',
                    name: 'Relatórios',
                    component: Reports,
                    children: [
                        {
                            path: 'professional_category',
                            name: 'Categorias de profissionais',
                            component: ProfessionalCategoryReport
                        },
                        {
                            path: 'incomplete_accounts',
                            name: 'Cadastros incompletos',
                            component: IncompleteAccountsReport
                        },
                        {
                            path: 'no_video_work_profiles',
                            name: 'Cadastros sem vídeo',
                            component: NoVideoWorkProfileReport
                        },
                        {
                            path: 'best_rated_profiles',
                            name: 'Perfis melhores avaliados',
                            component: BestRatedProfilesReport
                        },
                        {
                            path: 'messaging_log',
                            name: 'Logs de notificações',
                            component: MessagingLog
                        },
                        {
                          path: 'sympla_jobs_report',
                          name: 'Eventos Sympla',
                          component: SymplaJobsReport
                        }
                    ]
                },
            ]
        },
        {
            path: '/pages',
            redirect: '/pages/404',
            name: 'Pages',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [
                {
                    path: '404',
                    name: 'Page404',
                    component: Page404
                },
                {
                    path: '500',
                    name: 'Page500',
                    component: Page500
                },
                {
                    path: 'login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: 'register',
                    name: 'Register',
                    component: Register
                }
            ]
        }
    ]
}

